const initialState = [
  {
    type: "FIRST_TIME_BLINKERS",
    title: "First-time Blinkers",
    description: "Blinkers are usually made of leather or plastic cups that are placed on the side of the eyes, either attached to a bridle or to an independent hood. They are used to help a horse focus on the task at hand, in some instances aiding concentration. The fitting of first-time blinkers may also be an indication that more positive tactics are in the offing."
  },
  {
    type: "FIRST_TIME_VISOR",
    title: "First-time Visor",
    description: "Visors are basically the same as blinkers but the main difference is that they have small peep holes cut into the back of the cups which cover the eyes. Trainers believe these keep horses focused on what is in front, encouraging them to pay attention to the race rather than distractions, such as the crowds."
  },
  {
    type: "FIRST_TIME_CHEEK_PIECES",
    title: "First-time Cheekpieces",
    description: "Initially used in France, cheekpieces are now popular all around the world and they are used to partially obscure a horse’s sideways and rear vision, with the aim of getting the horse to concentrate. The strips of sheepskin can be white, black or brown and are fastened to each side of a horse’s bridle."
  },
  {
    type: "FIRST_TIME_HOOD",
    title: "First-time Hood",
    description: "In contrast to blinkers, and to some extent cheekpieces, which are both used to sharpen a horse’s focus and liven them up a little, a hood is considered more of a pacifier in order to calm a horse down if it has a tendency to race too keenly or be overly exuberant in the preliminaries. The fitting of a hood for the first time can have a significant influence and may help a horse produce an improved finishing effort."
  },
  {
    type: "FIRST_TIME_EYE_SHIELD",
    title: "First-time Eye-Shield",
    description: "An eye-shield is employed by a trainer most often when their horse is running on all-weather polytrack and fibresand racetracks. The sand-based nature of the surface causes ‘kickback’ for those horses behind the leaders, so an eye-shield is a protective mesh over the horse’s eyes to guard against the sandstorm."
  },
  {
    type: "FIRST_TIME_EYE_COVER",
    title: "First-time Eye-Cover",
    description: "Eye-covers are very similar in principle to blinkers and eye-shields, whereby the horse’s concentration is channelled on the race at hand rather than risking distraction from their peripheral vision. The first-time application of an eye-cover might just eke out that bit of improvement required in the horse to get its head in front."
  },
  {
    type: "FIRST_TIME_TONGUE_STRAP",
    title: "First-time Tongue-strap",
    description: "The tongue-strap, or tongue-tie as it’s commonly known, is utilised to help a horse with its breathing and prevent respiratory noises. The strap holds the tongue down during the race and in some instances can result in a greatly improved performance. It is not necessarily a precursor to a breathing operation, but can be an indication that the horse has had such issues or made a noise in the past."
  },
  {
    type: "TRAVELLERS_CHECK",
    title: "Travellers Check",
    description: "This identifies the 10 horses that have travelled the furthest, from stable to racecourse. Petrol costs can really mount up so it’s generally worthwhile keeping an eye on which trainers have opted to send their horse/s a long way in search of a victory."
  },
  {
    type: "AHEAD_OF_THE_HANDICAPPER",
    title: "Ahead of the Handicapper",
    description: "More often than not, horses are handed increased BHA ratings for winning races which means they will compete from higher marks in the future. If they’re turned out quickly under a penalty, or unpenalised in some instances, then they can be racing from a lower mark than for future races. The ‘Ahead of the Handicapper’ identifies these horses that may be competing on favourable terms."
  },
  {
    type: "WIND_SURGERY_SINCE_LAST_RUN",
    title: "Wind Surgery Since Last Run",
    description: "Sometimes, significant improvement in a horse’s form can be brought about by small, routine operations to improve its breathing. Horses that have had wind surgery since their last run are worth keeping an eye on, particularly if they’ve shown glimmers of promise in the past, or the market speaks particularly strongly in their favour."
  },
  {
    type: "HOT_JOCKEY",
    title: "Hot Jockey",
    description: "Jockeys who are in a rich vein of form are indicated under the ‘Hot Jockey’ Insight, which highlights where the jockey is boasting a strike rate of at least 30% (with a minimum of 2 wins or 4 rides) in the last 14 days. Confidence is vital, so those jockeys on the crest of a wave might be worth extra attention."
  },
  {
    type: "HOT_TRAINER",
    title: "Hot Trainer",
    description: "Trainers whose horses are coming into form will be highlighted with a ‘Hot Trainer’ Insight: those are the trainers showing a strike rate of at least 30% (with a minimum of 2 wins or 4 rides) in the last 14 days. Catching yards whose horses are starting to find the winning post more frequently can often be a potent asset to the punter."
  }
];

export default function reducer(state = initialState, action = {}) {
  return state;
}




// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/insights.js